// API-клиент для работы с backend.
import axios from 'axios';
import { getPlatform, getUser } from '../utils/platform';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Перехватчик для добавления Telegram ID в заголовки
client.interceptors.request.use((config) => {
  const token = localStorage.getItem('sova-token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  const user = getUser();
  if (user) {
    const platform = getPlatform();
    if (platform === 'telegram') {
      config.headers['X-Telegram-Id'] = user.id;
      config.headers['X-Telegram-Username'] = user.username || '';
      config.headers['X-Telegram-First-Name'] = user.first_name || '';
    }
  }
  return config;
});

// Перехватчик для обработки 403 (истечение подписки)
let onSubscriptionExpired = null;

export function setSubscriptionExpiredHandler(handler) {
  onSubscriptionExpired = handler;
}

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Удаляем токен, только если упал именно текущий: запоздавший 401 от
      // старого токена не должен стирать уже обновлённый (гонка при ре-логине
      // после удаления аккаунта — правка 2026-10-19)
      const sent = (error.config?.headers?.Authorization || '').replace('Bearer ', '');
      if (sent && sent === localStorage.getItem('sova-token')) {
        localStorage.removeItem('sova-token');
      }
    }
    if (error.response?.status === 403 && error.response?.data?.error === 'subscription_expired') {
      if (onSubscriptionExpired) {
        onSubscriptionExpired();
      }
    }
    return Promise.reject(error);
  }
);

export default client;
